import React, { useEffect } from "react";
import "../style/CreateAccount.css";
import { HiLocationMarker } from "react-icons/hi";
import { RxCross2 } from "react-icons/rx";

function CreateAccount() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <section>
      <div className="mainContainer pt-5">
        <h3>Create Account</h3>
        <p className="mt-md-3 mt-2 uploadNft">
          To upload NFTs you need to create an account
        </p>
        <div className="signupContainer">
          <div className="imageProfile">
            <img src="user 1.png" alt="profile" />
          </div>
          <label className="pt-3">profile image</label>
          <div className="nameRow">
            <div className="userName">
              <label>artist name</label>
              <input placeholder="Add name" className="text" />
            </div>
            <div className="userName">
              <label>user name</label>
              <input placeholder="Add name" />
            </div>
          </div>
          <div className="BioLocation">
            <div className="userName">
              <label>bio</label>
              <textarea placeholder="Add bio"></textarea>
            </div>
            <div className="userName">
              <label>location</label>
              <div className="position-relative d-flex align-items-center">
                <input placeholder="Sydney, Australia" />
                <HiLocationMarker className="svgClass opacity-50" />
              </div>
            </div>
          </div>
          <div className="tattooAdd">
            <div className="userName">
              <label>tattoo categories</label>
              {/* <input placeholder="Add name" className="text" /> */}
              <div className="dropdownss">
                <button
                  className="dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span className="opacity-50">Traditional</span>{" "}
                  <span>
                    <img
                      src="Vector (10).png"
                      alt="arrow"
                      className="mb-2 me-2 "
                    />
                  </span>
                </button>
                <div
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                >
                  <a className="dropdown-item" href="#">
                    All caltegories
                  </a>
                  <a className="dropdown-item" href="#">
                    Featured Collection
                  </a>
                  <a className="dropdown-item" href="#">
                    Top artists
                  </a>
                  <a className="dropdown-item" href="#">
                    recommended Collection
                  </a>
                  <a className="dropdown-item" href="#">
                    Trending Collection
                  </a>
                  <a className="dropdown-item" href="#">
                    In game Collection
                  </a>
                  <a className="dropdown-item" href="#">
                    popular Categories
                  </a>
                  <a className="dropdown-item" href="#">
                    Traditional
                  </a>
                  <a className="dropdown-item" href="#">
                    anime / fantacy
                  </a>
                  <a className="dropdown-item" href="#">
                    character NFT’s
                  </a>
                </div>
              </div>
              <div className="traditional">
                <div className="addedTraditon">
                  traditional <RxCross2 className="ms-2" />
                </div>
                <div className="addedTraditon">
                  blackwork <RxCross2 className="ms-2" />
                </div>
              </div>
            </div>
            <div className="userName">
              <label>add categories</label>
              <div className="position-relative">
                <input placeholder="Add category name" />
                <button className="addButton buttonClass position-absolute">
                  Add
                </button>
              </div>
              <div className="traditional">
                <div className="addedTraditon">
                  japanese <RxCross2 className="ms-2" />
                </div>
                <div className="addedTraditon">
                  crafted work <RxCross2 className="ms-2" />
                </div>
              </div>
            </div>
          </div>
          <div className="websiteStudio">
            <div className="userName">
              <label>current tattoo studio</label>
              <input placeholder="Studio name" className="text" />
            </div>
            <div className="userName">
              <label>website</label>
              <input placeholder="Enter website url" />
            </div>
          </div>
          <div className="socialMediaLink">
            <label>social media links</label>
            <div className="d-flex flex-wrap justify-content-between gap-3">
              <div className="userName position-relative justify-content-around align-items-end">
                <input placeholder="http://www.twitter.com/username" />
                <RxCross2 className="me-3 position-absolute cross" />
              </div>
              <div className="userName position-relative justify-content-around align-items-end">
                <input placeholder="http://www.twitter.com/username" />
                <RxCross2 className="me-3 position-absolute cross" />
              </div>
            </div>
            <button className="addButton buttonClass mt-2">Add</button>
          </div>
          <div className="connectWallets">
            <h6>connect wallet</h6>
            <div className="pt-2 d-flex justify-content-between flex-sm-row flex-column">
              <div className="metaMaskButton">
                <button>
                  <img src="image 48.png" alt="metamask" className="me-2" />
                  Metamask
                </button>
                <button className="coinborder">
                  <img
                    src="Coinbase-icon-symbol-1 1.png"
                    alt="metamask"
                    className="me-2 "
                  />
                  coinbase
                </button>
              </div>
              <div>
                <button className="submitButton buttonClass">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CreateAccount;
